import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { InputField } from 'Common/SemanticWrapper';
import { FieldEnum } from 'Common/FieldEnum';
import { InputMode } from 'Common/FormEnum';
import { isValidEmail } from 'Common/FormHelper';
import { ACCOUNT_SETUP_CONTACT_FORM_NAME } from 'Common/FormEnum';
import { normalizePhone } from 'Common/FormHelper';
import StateDropdown from 'Common/Components/StateDropdown/StateDropdown';

class StudentContactInfo extends Component {
  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <section className="student-form-component grid-spacing">
          <Form onSubmit={handleSubmit}>
            <Grid>
              <Grid.Row className={'remove-spacing'}>
                <Grid.Column width={6}>
                  <Field
                    name={FieldEnum.ParentFirstName}
                    component={InputField}
                    type="text"
                    maxLength={20}
                    label={'Parent/Guardian First Name'}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <Field
                    name={FieldEnum.ParentLastName}
                    component={InputField}
                    type="text"
                    maxLength={20}
                    label={'Parent/Guardian Last Name'}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className={'remove-spacing'}>
                <Grid.Column width={6}>
                  <Field
                    name={FieldEnum.ShipAddress1}
                    component={InputField}
                    type="text"
                    maxLength={60}
                    label={'Address 1'}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <Field
                    name={FieldEnum.ShipAddress2}
                    component={InputField}
                    type="text"
                    maxLength={30}
                    label={'Address 2'}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className={'remove-spacing'}>
                <Grid.Column width={6}>
                  <Field
                    name={FieldEnum.ShipCity}
                    component={InputField}
                    type="text"
                    label={'City'}
                    maxLength={20}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <StateDropdown name={FieldEnum.ShipState} />
                </Grid.Column>
                <Grid.Column width={2}>
                  <Field
                    name={FieldEnum.ShipZipCode}
                    component={InputField}
                    type="text"
                    maxLength={5}
                    mode={InputMode.Integer}
                    label={'Zip code'}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row className={'remove-spacing'}>
                <Grid.Column width={6}>
                  <Field
                    name={FieldEnum.Email}
                    component={InputField}
                    maxLength={50}
                    type="text"
                    label={'Contact Email Address'}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <Field
                    name={FieldEnum.ContactNumber}
                    component={InputField}
                    type="text"
                    maxLength={14}
                    mode={InputMode.Integer}
                    label={'Contact Phone'}
                    normalize={normalizePhone}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </section>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  if (
    values[FieldEnum.Email] &&
    _.trim(values[FieldEnum.Email]).length > 0 &&
    !isValidEmail(values[FieldEnum.Email])
  ) {
    errors[FieldEnum.Email] = 'Please enter a valid email address.';
  }
  if (
    values[FieldEnum.ContactNumber] &&
    _.trim(values[FieldEnum.ContactNumber]).length < 14
  ) {
    errors[FieldEnum.ContactNumber] = 'Please enter a valid number.';
  }
  if (
    values[FieldEnum.ZipCode] &&
    _.trim(values[FieldEnum.ZipCode]).length < 5
  ) {
    errors[FieldEnum.ZipCode] = 'Please enter valid zip code.';
  }
  return errors;
};
const mapStateToProps = ({ AccountSetupState }) => {
  return {};
};

StudentContactInfo = connect(mapStateToProps, null)(StudentContactInfo);

export default reduxForm({
  validate,
  enableReinitialize: true,
  form: ACCOUNT_SETUP_CONTACT_FORM_NAME,
})(StudentContactInfo);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/StudentContactInfo.js